export default __webpack_public_path__ + "static/media/trr-food-salad-kale.84dfb5bb.png";